import api from '@/api'

export default {
  async getLogin() {
    try {
      const headers = {
        'Access-Control-Allow-Origin': '*'
      }
      return api.request('get', 'api/v1/payments/xero/connections', true, null, headers)
    } catch (error) {
      throw error;
    }
  },

  async handleCallback({ code = null }) {
    try {
      if (!code) return;
      return api.request('get', '/api/v1/payments/xero/connect/token?code=' + code, true)
    } catch (error) {
      throw error;
    }
  },
  async getTenant() {
    try {
      return api.request('get', '/api/v1/payments/xero/tenant', true)
    } catch (error) {
      throw error;
    }
  },
  async syncResoures(resource) {
    try {
      return api.request('get', '/api/v1/payments/xero/resource/' + resource, true)
    } catch (error) {
      throw error;
    }
  },
  async getXeroContacts() {
    try {
      return api.request('get', '/api/v1/payments/xero/contacts', true)
    } catch (error) {
      throw error;
    }
  },
  updateXeroContact(id, data) {
    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/payments/xero/contacts/update/' + id, true, data)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/views/Xero/XeroAPIs.js